import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-form-error",
    templateUrl: "./form-error.component.html",
    styleUrls: ["./form-error.component.scss"],
    standalone: false
})
export class FormErrorComponent implements OnInit {
  @Input() showValidation = false;
  @Input() isReactive = false;
  @Input() reactiveControl;
  @Input() modelControl;

  finalizationStarted = false;

  constructor() {}

  ngOnInit(): void {
    
  }
}
